/**
 * A CSS font-size that keeps a one-line monospace string inside its container: at most `maxPx`,
 * and never wider than the nearest `@container` (DM Mono glyphs are about 0.6em wide).
 */
export function fitFontSize(text: string, maxPx: number, charEm = 0.62): string {
  const chars = Math.max(1, text.length);
  const cqw = Math.floor((100 / (chars * charEm)) * 100) / 100;
  return `min(${maxPx}px, ${cqw}cqw)`;
}
